import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NotAuthorizedComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
